"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EDSContext = require("../../EDSContext/EDSContext");
var _styles = _interopRequireDefault(require("../../styles"));
var _core = require("@ellucian/react-design-system/core");
var _tokens = require("../../styles/tokens");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = function styles(theme) {
  return {
    contentPadding: {
      paddingBottom: _tokens.spacing40
    },
    paper: {
      width: theme.spacing(100) // 400 px
    },

    popperTitle: {
      fontSize: theme.typography.h4.fontSize,
      fontWeight: theme.typography.h4.fontWeight,
      marginBottom: _tokens.spacing40
    },
    popperActions: {
      textAlign: 'right',
      '& button:not(:last-child)': {
        marginRight: _tokens.spacing40
      }
    }
  };
};
var VideoPopper = function VideoPopper(props) {
  var _containerRef$current, _containerRef$current2;
  var classes = props.classes,
    edsContext = props.edsContext,
    url = props.url,
    title = props.title,
    isPopperOpen = props.isPopperOpen,
    _props$isEdit = props.isEdit,
    isEdit = _props$isEdit === void 0 ? false : _props$isEdit,
    onInsertVideo = props.onInsertVideo,
    onClose = props.onClose,
    containerRef = props.containerRef;
  var _useState = (0, _react.useState)({
      url: url != null ? url : '',
      title: title != null ? title : ''
    }),
    video = _useState[0],
    setVideo = _useState[1];
  var _useState2 = (0, _react.useState)(''),
    urlError = _useState2[0],
    setUrlError = _useState2[1];
  var urlHelperMessage = edsContext.formatMessage('component.RichTextEditor.videoPopperURLHelper');
  var _useState3 = (0, _react.useState)((_containerRef$current = containerRef == null ? void 0 : (_containerRef$current2 = containerRef.current) == null ? void 0 : _containerRef$current2.querySelector('button.ql-video')) != null ? _containerRef$current : document.querySelector('button.ql-video')),
    videoPopperAnchor = _useState3[0],
    setVideoPopperAnchor = _useState3[1];
  var saveButtonRef = (0, _react.useRef)();
  var urlInputRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var _containerRef$current3, _containerRef$current4;
    setVideo({
      url: url,
      title: title
    });
    setVideoPopperAnchor((_containerRef$current3 = containerRef == null ? void 0 : (_containerRef$current4 = containerRef.current) == null ? void 0 : _containerRef$current4.querySelector('button.ql-video')) != null ? _containerRef$current3 : document.querySelector('button.ql-video'));
  }, [containerRef, url, title]);
  var handleTitleChange = (0, _react.useCallback)(function (titleValue) {
    setVideo(function (prevVideo) {
      return (0, _extends2.default)({}, prevVideo, {
        title: titleValue
      });
    });
  }, []);
  var handleUrlChange = (0, _react.useCallback)(function (urlValue) {
    // disable the helper text when text is inputted
    if (urlError && urlValue) {
      setUrlError('');
    }
    setVideo(function (prevVideo) {
      return (0, _extends2.default)({}, prevVideo, {
        url: urlValue
      });
    });
  }, [urlError]);

  // fires the onInsertVideo prop function and closes the popper if url is present
  var handleInsertVideo = (0, _react.useCallback)(function () {
    if (video.url === '') {
      setUrlError(urlHelperMessage);
    } else {
      onInsertVideo(video);
      setVideo({
        url: '',
        title: ''
      });
      setUrlError('');
    }
  }, [video, onInsertVideo, urlHelperMessage]);
  var handleCancelVideo = (0, _react.useCallback)(function () {
    setVideo({
      url: '',
      title: ''
    });
    setUrlError('');
    onClose();
  }, [onClose]);

  // traps and wraps the focus within the popper
  var wrapFocus = function wrapFocus(e) {
    // ignore key-presses that are not tabs
    if (!(e.key === 'Tab')) {
      return;
    }
    if (document.activeElement === saveButtonRef.current && !e.shiftKey) {
      // focus start input
      e.preventDefault();
      urlInputRef.current.focus();
    }
    if (document.activeElement === urlInputRef.current && e.shiftKey) {
      // focus save button
      e.preventDefault();
      saveButtonRef.current.focus();
    }
  };

  // allows the user to press escape to close the popper
  var escapePopper = function escapePopper(e) {
    if (e.key === 'Escape') {
      handleCancelVideo();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_core.Popper, {
    id: "RTE_videoPopper",
    role: "alertdialog",
    open: isPopperOpen,
    onClickAway: handleCancelVideo,
    onClose: onClose,
    classes: {
      paperRoot: classes.paper
    },
    title: isEdit ? edsContext.formatMessage('component.RichTextEditor.videoPopperTitleEdit') : edsContext.formatMessage('component.RichTextEditor.videoPopperTitleAdd'),
    TitleTypographyProps: {
      classes: {
        root: classes.popperTitle
      }
    },
    anchorEl: videoPopperAnchor,
    placement: edsContext.dir === 'ltr' ? 'bottom-start' : 'bottom-end',
    onKeyDown: function onKeyDown(e) {
      return escapePopper(e);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentPadding
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    "data-id": "videoPopperURL",
    label: edsContext.formatMessage('component.RichTextEditor.videoPopperURL'),
    onChange: function onChange(e) {
      return handleUrlChange(e.target.value);
    },
    type: "text",
    value: video.url,
    fullWidth: true
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: true,
    onKeyDown: function onKeyDown(e) {
      return wrapFocus(e);
    },
    inputRef: urlInputRef,
    error: urlError !== '',
    helperText: urlError,
    required: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentPadding
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    "data-id": "videoPopperTitle",
    label: edsContext.formatMessage('component.RichTextEditor.videoPopperTitleAttr'),
    onChange: function onChange(e) {
      return handleTitleChange(e.target.value);
    },
    type: "text",
    value: video.title,
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.popperActions
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    "data-id": "videoPopperCancel",
    onClick: handleCancelVideo,
    color: "secondary",
    "aria-label": edsContext.formatMessage('component.RichTextEditor.cancel')
  }, edsContext.formatMessage('component.RichTextEditor.cancel')), /*#__PURE__*/_react.default.createElement(_core.Button, {
    "data-id": "videoPopperSave",
    onClick: handleInsertVideo,
    color: "primary",
    "aria-label": edsContext.formatMessage('component.RichTextEditor.save'),
    onKeyDown: function onKeyDown(e) {
      return wrapFocus(e);
    },
    ref: saveButtonRef
  }, edsContext.formatMessage('component.RichTextEditor.save'))));
};
VideoPopper.propTypes = {
  /**
   * @ignore
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * Ref to the parent RichTextEditor container.
   * @ignore
  */
  containerRef: _propTypes.default.object,
  /**
  * Initial value for video url
  */
  url: _propTypes.default.string,
  /**
  * Initial value for the iframe title attribute
  */
  title: _propTypes.default.string,
  /**
  * Indicates if the Popper should open or close
  */
  isPopperOpen: _propTypes.default.bool,
  /**
  * Indicates if the Popper's title should be edit or add
  */
  isEdit: _propTypes.default.bool,
  /**
  * Callback fired when the save button is clicked
  * `@param {object} video`   The video with url and alt text to insert
  *
  */
  onInsertVideo: _propTypes.default.func.isRequired,
  /**
   * Callback fired when the cancel button is clicked
   */
  onClose: _propTypes.default.func.isRequired
};
var _default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(VideoPopper));
exports.default = _default;